import{m as e}from"./chunk-HBP5N4FR.js";e();function i(){return typeof sessionStorage!="undefined"}export{i as a};
//# sourceMappingURL=chunk-NM43ACPN.js.map
